import React from "react";
import DiscoverAndBuildTabDesktop from "./DiscoverAndBuildTabDesktop";
import DiscoverAndBuildItems from "./DiscoverAndBuildItems";
import DiscoverAndBuildMobile from "./DiscoverAndBuildMobile";

interface DiscoverAndBuildProps {}

const discoverAndBuild: React.SFC<DiscoverAndBuildProps> = (props) => {
  return (
    <div className="subaru_discover_and_build">
      <div className="subaru_airbag_wrapper row hidden">
        <div className="subaru_airbag col-lg-2 col-xs-2">
          Urgent Airbag Recall
        </div>
        <div className="subaru_contact col-lg-3 col-xs-6">
          <a href="/takata-recall">Click here </a> for more information
        </div>
      </div>

      <div className="subaru_airbag_wrapper row hidden">
        <div className="subaru_airbag_bg" />
        <div className="subaru_airbag col-lg-9 col-xs-12">
          <span>
            TAKATA AIRBAG CLASS ACTION: Subaru Australia has reached an
            in-principle settlement of a class action relating to Takata
            airbags.
          </span>
        </div>
        <div className="subaru_contact col-lg-4 col-xs-12">
          For more information and to register for settlement{" "}
          <a href="/takata-recall">Click here</a>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-12 col-xs-12">
          <div className="subaru_title col-lg-12 col-xs-12 margin-xs-screen-20px">
            <p>Discover and Build</p>
          </div>
        </div>
      </div>
      <div className="subaru_discover_wrapper desktop">
        <DiscoverAndBuildTabDesktop />
        <DiscoverAndBuildItems />
      </div>
      <div className="subaru_discover_wrapper mobile">
        <DiscoverAndBuildMobile />
      </div>
    </div>
  );
};

export default discoverAndBuild;
